import React, { useState } from "react";
import PropTypes from "prop-types";
// // import styles from "./input-text.module.css";
import useToggle from "../../hooks/useToggle";

const InputText = ({
  showlabel,
  value = "",
  name = "",
  id = "",
  className = "form-control",
  text = "",
  placeholder = "",
  onChange = () => {},
  onBlurCallback = () => {},
  validator = () => {},
  errorMessage = "",
  inputRef,
  onFocusCallback = () => {},
  maxLength = "",
  onKeyPress = () => {},
  type = "text",
  readonly = false,
  validationError = false,
  disabled = false,
}) => {
  const [isTouched, setIsTouched] = useState(false);
  const [isFocused, setIsFocused] = useToggle(false);
  const [hasError, setHasError] = useState(false);
  const [error, setError] = useState(errorMessage);
  const [isEmpty, setisEmpty] = useState(true);

  const onChangeHandler = (e) => {
    var htmlRegexG = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g;
    e.target.value = e.target.value.replace(htmlRegexG, "");
    const inputValue = e.target.value;

    if (validator(inputValue)) {
      setHasError(false);
      setError("");
    } else {
      setHasError(true);
      setError(errorMessage);
    }
    onChange(e);
  };

  const onFocus = () => {
    setIsFocused();
    setIsTouched(true);
    onFocusCallback();
  };

  const onBlur = (e) => {
    const inputValue = e.target.value;
    setIsFocused();
    onBlurCallback(e.target.value);
    if (inputValue.trim().length > 0) {
      setisEmpty(false);
    }
    if (inputValue.trim().length === 0) {
      setisEmpty(true);
    }
  };

  return (
    <>
      {showlabel && <label className="form-label">{text}</label>}
      <input
        ref={inputRef}
        id={id}
        placeholder={placeholder}
        type={type}
        name={name}
        className={`${
          "form-control w-full focus:outline-none focus:ring-blue-500 focus:border-blue-500  bg-white text-gray-500" +
          className
        } ${!isEmpty ? "success" : ""}`}
        value={value}
        maxLength={maxLength}
        onChange={(e) => onChangeHandler(e)}
        onFocus={(e) => onFocus(e)}
        onBlur={(e) => onBlur(e)}
        autoComplete="off"
        onKeyPress={(e) => onKeyPress(e)}
        disabled={disabled}
        {...(readonly === true && { readOnly: "readonly" })}
      />

      {isTouched && !isFocused && hasError && <span className="">{error}</span>}
    </>
  );
};

InputText.propTypes = {
  value: PropTypes.string,
  showlabel: PropTypes.bool,
  id: PropTypes.string,
  text: PropTypes.string,
  onChange: PropTypes.func,
  onBlurCallback: PropTypes.func,
  maxLength: PropTypes.number,
  validator: PropTypes.func,
  errorMessage: PropTypes.string,
  inputRef: PropTypes.object,
  onFocusCallback: PropTypes.func,
};
export default InputText;
